import { Avatar, Badge, Button, Card, Col, Dropdown, Flex, List, MenuProps, Modal, Row, Space, Typography } from "antd";
import React, { useEffect } from "react";
import LeaveStatsCard from "./leaveStatsCard";
import BalanceLeaves from "./balanceLeaves";
import CommonCalendar from "./calender";
import './index.scss';
import moment from "moment";
import { DownOutlined } from "@ant-design/icons";
import BaseComponent from "../../../components/BaseComponent";
import { leavesConfirg } from "../../../entity/leaves/leavesConfig";
import ReusableTable from "../../../components/TableComponent";
import { useDispatch } from "react-redux";
import { getData } from "../../../actions/apiCall";
import InfiniteScrollList from "../../../components/Forms/ListView/InfiniteScrollList";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import HolidayList from "./HolidayList";

const { Title, Text } = Typography;

const LeaveComponent: React.FC = () => {
    const [leavesBalance, setLeavesBalance] = React.useState([]);
    const [leavesStats, setLeavesStats] = React.useState(null);
    const [viewHolidays, setViewHolidays] = React.useState(false);
    const dispatch = useDispatch();


    const events = [];

    const attendanceData: Record<string, string> = {
        "2025-02-03": "A",
        "2025-02-04": "A",
        "2025-02-05": "A",
        "2025-02-06": "L",
        "2025-02-07": "L",
        "2025-02-10": "P",
        "2025-02-11": "A",
        "2025-02-12": "P",
        "2025-02-13": "A",
    };



    // const getLeaveData = async () => {
    //     const response = await dispatch(getData('/leaves/user/leaves/all'));
    //     if (response.code === 200) {
    //         console.log(response.data);
    //     }
    // }


    const getStatusStyle = (status: string) => {
        switch (status) {
            case "A":
                return "bg-red-300 text-red-900";
            case "P":
                return "bg-blue-300 text-blue-900";
            case "L":
                return "bg-yellow-300 text-yellow-900";
            case "W":
                return "bg-gray-300 text-gray-900";
            default:
                return "";
        }
    };

    const dateCellRender = (value: Dayjs) => {
        const formattedDate = value.format("YYYY-MM-DD");
        let status = attendanceData[formattedDate];
        const dayOfWeek = value.day(); // Sunday = 0, Monday = 1, ..., Saturday = 6

        if (dayOfWeek === 0 || dayOfWeek === 6) {
            status = "W";
        }

        return status ? (
            <div className={`text-center rounded-md px-1 ${getStatusStyle(status)}`}>
                {status}
            </div>
        ) : null;
    };



    const handleMenuClick: MenuProps['onClick'] = (e) => {
        console.log('click', e);
    };

    const items: MenuProps['items'] = [
        {
            label: '1st menu item',
            key: '1',
        },
        {
            label: '2nd menu item',
            key: '2',
        },
        {
            label: '3rd menu item',
            key: '3',
        },
        {
            label: '4rd menu item',
            key: '4',
        },
    ];

    useEffect(() => {
        getBalanceLeaves();
        getLeavesStats();
    }, []);

    const getBalanceLeaves = async () => {
        const response = await dispatch(getData('/leaves/user/balance/leaves'));
        if (response.code === 200) {
            setLeavesBalance(response.data);
        }
    }

    const getLeavesStats = async () => {
        const response = await dispatch(getData('/leaves/user/leaves/stats'));
        if (response.code === 200) {
            console.log(response.data);
            setLeavesStats(response.data);
        }
    }

    const menuProps = {
        items,
        onClick: handleMenuClick,
    };
    return <Row gutter={[8, 8]}>
        <Col span={24}>
            <Flex justify="space-between">
                <Space direction="horizontal">
                    <Title level={5}>
                        Your Leave Balance as of {moment().format('DD MMM YYYY')}
                    </Title>
                    <Badge size="default" count={5}>
                        <Button type="text">Pending Requests</Button>
                    </Badge>
                </Space>
                <Space direction="horizontal">
                    <Dropdown menu={menuProps}>
                        <Button>
                            <Space>
                                Button
                                <DownOutlined />
                            </Space>
                        </Button>
                    </Dropdown>
                    <Button onClick={() => setViewHolidays(true)}>List of holidays</Button>
                    <Button>Optional of holidays</Button>
                </Space>
            </Flex>
        </Col>
        <Col span={8}>
            <LeaveStatsCard
                totalLeavesBalance={leavesStats?.balanceLeaves}
                totalLeavesConsumed={leavesStats?.totalAppliedLeaves}
                totalHolidaysBalance={3}
                pendingRequests={1}
            />
        </Col>
        <Col span={8}>
            <Card>
                <Title level={5}>Latest Leaves</Title>
                <InfiniteScrollList
                    apiUrl="/leaves/user/leaves/all"
                    height={300}
                    renderItem={(item, index) => (
                        <List.Item>
                            <List.Item.Meta
                                avatar={<Avatar src={`${process.env.FILE_URL}${item?.user?.avatar}`} />}
                                title={item?.leaves?.leaveType?.leaveName}
                                description={<Text type="secondary" ellipsis>
                                    {moment(item?.startDate).format('DD MMM YYYY')} - {moment(item?.endDate).format('DD MMM YYYY')} - {item?.reason}
                                </Text>}
                            />
                        </List.Item>
                    )}
                />
            </Card>
        </Col>
        <Col span={8}>
            <CommonCalendar events={events} dateRender={dateCellRender} />
        </Col>
        <Col span={24}>
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <Title level={5}>Balance Leaves</Title>
                </Col>
                {leavesBalance.map(ele => <Col span={8}>
                    <BalanceLeaves
                        title={ele.leaveName}
                        annualQuota={ele.yearlyQuota}
                        available={ele.available}
                        consumed={ele.consumed}
                        totalAvailable={ele.yearlyQuota}
                    />
                </Col>)}
            </Row>
        </Col>
        <Col span={24}>
            <ReusableTable config={leavesConfirg} />
        </Col>
        <Modal
            open={viewHolidays}
            title="Holidays of 2025"
            width={700}
            footer={null}
            onCancel={() => setViewHolidays(false)}
        >
            <HolidayList />
        </Modal>
    </Row>
}

export default LeaveComponent;